import { Component, type ErrorInfo, type ReactNode } from 'react'
import ReactDOM from 'react-dom/client'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import App from './App.tsx'
import { RootZoomBridge } from './components/RootZoomBridge'
import './index.css'
import { antdTheme } from './theme/antdTheme'
import { ipcTokens } from './theme/ipcTokens'

class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('App error:', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: 'sans-serif', maxWidth: 600 }}>
          <h2 style={{ color: ipcTokens.destructive }}>页面加载出错</h2>
          <pre style={{ background: '#f5f5f5', padding: 12, overflow: 'auto', fontSize: 12 }}>
            {this.state.error.message}
          </pre>
          <p style={{ color: '#666', fontSize: 12 }}>请打开开发者工具 (F12) 查看控制台获取完整错误信息。</p>
        </div>
      )
    }
    return this.props.children
  }
}

// 不使用 StrictMode：React 18 开发环境下会对组件做一次「卸载再挂载」，useEffect 内请求会发两遍，Network 里所有 Tab 首进数据接口都会重复。
ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <RootZoomBridge>
      <ConfigProvider
        locale={zhCN}
        componentSize="middle"
        theme={antdTheme}
        modal={{ maskClosable: false }}
      >
        <App />
      </ConfigProvider>
    </RootZoomBridge>
  </ErrorBoundary>,
)
